import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import ComboReportTable from "./components/ComboReportTable";

interface Props {
	getComboReport: (data: Record<string, any>) => Promise<(string | number)[][]>;
}

export const OrganizationReportsCombo = ({ getComboReport }: Props) => {
	const [data, setData] = useState<(string | number)[][] | undefined>();
	const [loading, setLoading] = useState(false);
	const { addFlash } = useFlash();
	const form = useForm<{ data: "string" }>({
		criteriaMode: "all",
	});
	const { formState, register, handleSubmit } = form;
	const { t } = useTranslation();

	const fetchData = handleSubmit(async (formData) => {
		setLoading(true);
		let parsedFormData;

		try {
			parsedFormData = JSON.parse(formData.data);
		} catch (err) {
			addFlash({
				type: "danger",
				msg: "wrong_data",
			});
			setLoading(false);
			setData(undefined);
			return;
		}

		try {
			const res = await getComboReport(parsedFormData);
			setData(res);
		} catch (err) {
			handleError.alert(err, addFlash);
			setData(undefined);
		}
		setLoading(false);
	});

	return (
		<FormDirty formState={formState}>
			<div className="mb-3">
				<FormInput name="data" errors={formState.errors} register={register} as="textarea" />
				<ButtonLoading loading={loading} onClick={() => fetchData()}>
					{t("lib:common.action.send")}
				</ButtonLoading>
			</div>
			<ComboReportTable data={data} loading={loading} />
		</FormDirty>
	);
};
